import { Box } from '@mui/material'
import Chip from '@mui/material/Chip'
import { styled } from '@mui/material/styles'

export const FilterHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  p: {
    fontWeight: 500,
    fontFamily: theme.typography.fontFamily,
  },
}))

export const TagWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.primary.main,
  marginBottom: '4px',
  fontFamily: theme.typography.fontFamily,
}))

export const ChipWrapper = styled(Chip)({
  marginTop: '3px',
  '& .MuiChip-deleteIconColorPrimary': {
    color: 'inherit',
    fontSize: '18px',
  },
})

export const ChipsWrapper = styled('div')({
  marginTop: '8px',
})
